:host {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  gap: 15px;
  border-top: 1px solid var(--solid-ui-color-slate-200);
}
